/// <reference path="../app.ts" />
namespace Cfnc {
    "use strict";

    interface ItaapLandingScope extends ng.IScope {
        vm: TaapLanding;
    }

    interface ItaapLanding {
        
    }

    class TaapLanding implements ItaapLanding {
        static controllerId: string = "taapLanding";
        static $inject: string[] = ["$scope", "common"];

        constructor(private $scope: ItaapLandingScope, private common: ICommonFactory) {
            

            this.activate();
        }

        activate() {
            var promises = [];
            this.common.activateController(promises, TaapLanding.controllerId);
        }
    }

    angular.module("app").controller(TaapLanding.controllerId, TaapLanding);
}